
<header class="header">
  <app-header (userMenuToggle)="toggleUserOptionsMenu()" (mainMenuToggle)="toggleMainMenu($event)" [sendCloseMenu]=isMenuOpened></app-header>
</header>

<div class="main">
  <mat-sidenav-container [hasBackdrop]="true" (backdropClick)="closeMenu()">
    <mat-sidenav #SideNavMenu opened="false" class="side-nav" role="navigation" [fixedInViewport]="true" fixedTopGap="0" mode="over" position="start" (click)="closeMenu()">
      <app-navigation-bar>
        <router-outlet></router-outlet>
      </app-navigation-bar>
    </mat-sidenav>
    <mat-sidenav #Drawer class="user-panel" role="region" [fixedInViewport]="true" fixedTopGap="0" mode="over" position="end">
      <div>
        <div _ngcontent-nax-c9 ng-class="ng-pristine ng-valid ng-touched" class="user-panel__form-inner">
          <div class="user-panel__close" (click)="toggleUserOptionsMenu()">
            <i class="material-icons">close</i>
          </div>
        </div>

        <div class="user-panel__holder">
          <h2 class="user-panel__heading">My details</h2>
          <div class="user-panel__details">
            <div class="user-panel__initials">{{userInitials}}</div>
            <ul class="user-panel__list">
              <li class="user-panel__item">
                <label class="user-panel__name">{{userName}}</label>
              </li>
              <li class="user-panel__item">
                <label>{{userEmail}}</label>
              </li>
              <li class="user-panel__item" (click)="signout()">
                <label class="user-panel__link">Sign out</label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content role="region" class="page-content" [ngClass]="{ public: isSrfsOrAdminUser === false }">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<footer class="footer">
  <app-footer></app-footer>
</footer>
